export const darkerMapStyle =  [
    { elementType: "geometry", stylers: [{ color: "#e0e0e0" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [{ color: "#d6d6d6" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#cfcfcf" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#b8d3c3" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dedede" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#c6c6c6" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#d3d3d3" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#b3d1e0" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3e606f" }],
    },
  ];